var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegisterImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 574,
    height: 507,
    viewBox: "0 0 574 507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.781 1H55V92.3226H239.781V1Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01206 250.459C18.6155 248.405 36.0462 238.174 48.0259 255.564C56.2836 267.564 54.209 283.978 72.6159 284.832C79.9177 285.178 86.5075 282.798 93.1177 287.049C98.8737 290.751 101.782 297.646 104.284 303.707C106.44 308.914 107.497 316.256 110.874 320.853C116.386 328.358 123.789 326.06 131.986 326.955C139.776 327.809 147.606 330.656 152.508 337.185C158.996 345.829 155.762 356.182 159.342 365.355C159.342 365.355 166.644 403.735 125.071 401.091C115.247 400.46 105.565 401.559 96.6567 395.416C89.9245 390.779 86.7516 383.07 85.5719 375.321C84.3516 367.185 86.3245 359.68 78.5956 354.494C73.8566 351.321 66.4938 350.568 61.1853 348.636C55.0226 346.379 48.0259 343.755 44.0801 338.162C39.5445 331.734 41.6598 325.043 41.0089 317.761C39.3818 299.415 23.0698 302.161 10.7443 294.412C-7.13378 283.165 2.36459 265.347 3.80867 250.663L4.01206 250.459Z",
    fill: "#4D53E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3547 274.988L159.667 399.992",
    stroke: "white",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4089 298.48L83.4971 326.914",
    stroke: "white",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M130.013 371.558L104.508 375.504",
    stroke: "white",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1645 311.233L46.1135 309.687",
    stroke: "white",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.773 336.168C158.773 336.168 173.661 210.737 56.2638 125.841C23.0297 253.998 140.366 358.338 140.366 358.338L158.773 336.168Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.657 175.957L101.335 234.838",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.437 264.168L60.3521 234.391",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6704 256.642L122.589 286.256",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2632 125.862L148.806 349.714",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M562.219 181.509L556.361 144.431L565.433 137.068L541.819 107.902L532.727 115.245L497.683 101.78L495.873 90.2478L458.774 96.1258L460.605 107.658L431.418 131.272L420.516 127.082L407.072 162.126L417.974 166.316L423.832 203.394L414.76 210.757L438.374 239.923L447.466 232.581L482.51 246.045L484.32 257.578L521.419 251.7L519.588 240.167L548.775 216.554L559.656 220.744L573.121 185.699L562.219 181.509ZM518.144 184.682C512.185 200.16 494.815 207.91 479.337 201.95C463.839 196.011 456.11 178.621 462.049 163.143C468.008 147.665 485.378 139.936 500.856 145.875C516.354 151.814 524.083 169.204 518.144 184.682Z",
    fill: "#C7D0D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.362 170.206H483.873C490.597 170.206 496.052 175.661 496.072 182.385V411.174H81.1838V182.384C81.1838 175.661 86.6383 170.206 93.362 170.206Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.62
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M477.263 187.042H99.9724V394.338H477.263V187.042Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M504.172 430.685H73.0434C66.5552 430.685 61.2874 425.417 61.2874 418.928V411.484H515.928V418.928C515.928 425.417 510.68 430.685 504.172 430.685Z",
    fill: "#C7D0D9",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M313.838 420.291H263.377C259.471 420.291 256.299 417.118 256.299 413.213V411.484H320.936V413.213C320.936 417.118 317.763 420.291 313.838 420.291Z",
    fill: "#4D53E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M531.324 377.314H348.943C340.462 377.314 333.587 370.44 333.587 361.958V250.052C333.587 241.571 340.462 234.696 348.943 234.696H531.324C539.806 234.696 546.68 241.571 546.68 250.052V361.958C546.68 370.44 539.785 377.314 531.324 377.314Z",
    fill: "#FFC405"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9614 430.684H546.68",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M167.478 298.602H300.76V219.503L167.478 239.415V298.602Z",
    fill: "#4D53E0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M218.447 88.8244C218.447 88.8244 233.783 68.4039 239.417 66.5327C246.108 69.909 257.457 81.1769 257.457 81.1769L251.824 87.1973L259.085 83.9023L266.813 91.8753L240.678 117.218L218.447 88.8244Z",
    fill: "#4D53E0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M353.947 165.706C353.947 165.706 353.194 149.354 360.435 144.187C363.852 141.747 377.622 136.296 377.622 136.296L380.449 141.645L371.154 146.445L391.167 147.299L401.601 137.984L405.547 141.096L393.425 159.971L377.927 165.706H353.947Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M165.545 506L186.352 484.604H203.925V506H165.545Z",
    fill: "#4D53E0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M279.993 506L266.529 484.604H248.956V506H279.993Z",
    fill: "#4D53E0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M290.285 298.195V490.278H236.387V337.063H229.349L219.464 490.278H165.545L175.43 337.063L177.952 298.195H290.285Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M315.974 203.293C315.974 158.893 281.967 139.083 237.567 138.025C236.651 138.005 235.736 137.984 234.821 137.984C168.047 137.984 146.976 186.534 143.803 194.914C136.766 213.565 116.935 272.06 180.8 299.111C200.021 307.247 213.749 287.518 224 282.229C241.878 273.036 248.326 270.717 248.326 270.717L315.974 203.293Z",
    fill: "#4D53E0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M303.784 282.302L229.502 208.02L133.992 303.529L208.274 377.811L303.784 282.302Z",
    fill: "#C7D0D9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M291.639 277.26L234.544 220.164L151.446 303.262L208.541 360.358L291.639 277.26Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M286.401 257.375L276.455 267.321L244.482 235.348L254.428 225.402L265.33 236.304C268.177 234.27 272.143 234.554 274.706 237.097C277.248 239.639 277.533 243.626 275.499 246.473L286.401 257.375Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M219.159 246.392L218.447 250.887L226.746 248.284",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M227.132 254.12L262.848 289.836",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M209.458 256.073L208.766 260.589L217.044 257.985",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M217.43 263.822L253.166 299.538",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M199.776 265.775L199.064 270.27L207.342 267.667",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M207.749 273.504L243.465 309.24",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M231.586 150.005C238.318 150.005 243.769 144.554 243.769 137.822V98.262H219.423V137.822C219.403 144.554 224.854 150.005 231.586 150.005Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M254.386 110.669C252.922 114.106 248.956 115.713 245.518 114.269C244.99 114.045 244.502 113.76 244.054 113.414C242.671 115.489 240.901 117.218 238.888 118.519C234.047 121.672 227.762 122.425 222.047 120.004C212.874 116.119 208.583 105.543 212.467 96.3701C216.352 87.1972 226.929 82.9056 236.101 86.7904C242.325 89.4141 246.291 95.1294 246.983 101.394C248.224 101.17 249.546 101.292 250.786 101.821C254.224 103.265 255.83 107.231 254.386 110.669Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M243.912 109.082C243.912 109.082 245.437 106.011 248.346 107.76",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M286.4 225.401C286.4 225.401 293.539 257.883 333.363 250.866C373.187 243.849 382.95 165.706 382.95 165.706H352.136L329.6 210.798C329.6 210.798 313.248 168.431 292.787 153.93C280.298 145.062 286.4 225.401 286.4 225.401Z",
    fill: "#4D53E0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M300.292 212.669V246.392",
    stroke: "white",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M236.102 86.7905C243.912 90.6753 246.76 100.255 241.471 105.319C246.983 101.394 246.983 101.394 246.983 101.394L255.77 95.821C255.77 95.821 239.234 83.6583 236.102 86.7905Z",
    fill: "#4D53E0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M207.993 291.85L219.2 303.117L228.23 313.796L224.427 317.599L227.763 321.992L209.051 336.535L184.745 307.307L207.993 291.85Z",
    fill: "white",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M223.878 324.799L215.844 315.626",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M218.61 328.399L210.556 319.246",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M213.647 332.385L205.613 323.212",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M224.549 317.782L218.61 310.927",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M177.993 214.378C172.704 225.646 174.128 237.28 178.603 247.937C188.406 271.388 212.915 290.182 212.915 290.182L181.918 313.287C181.918 313.287 140.284 278.039 138.148 254.181",
    fill: "#4D53E0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M177.993 214.378C172.705 225.646 174.128 237.28 178.603 247.937",
    stroke: "white",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M94.434 53.769C95.139 53.769 95.7158 53.716 96.1644 53.61C96.6343 53.4827 97.0082 53.3237 97.2859 53.1328C97.5636 52.9207 97.7559 52.6768 97.8627 52.4011C97.9695 52.1254 98.0229 51.8179 98.0229 51.4786C98.0229 50.7575 97.6811 50.1637 96.9975 49.6971C96.3139 49.2093 95.139 48.6897 93.4727 48.1383C92.7464 47.8838 92.0201 47.5975 91.2938 47.2794C90.5675 46.9401 89.9159 46.5265 89.3392 46.0387C88.7624 45.5297 88.2924 44.9253 87.9293 44.2254C87.5661 43.5044 87.3845 42.6349 87.3845 41.6169C87.3845 40.5989 87.5768 39.687 87.9613 38.8811C88.3458 38.0539 88.8906 37.3541 89.5955 36.7815C90.3005 36.2089 91.1549 35.7741 92.159 35.4772C93.163 35.1591 94.2952 35 95.5555 35C97.0509 35 98.3433 35.1591 99.4328 35.4772C100.522 35.7953 101.419 36.1452 102.124 36.527L100.682 40.4398C100.063 40.1217 99.3687 39.846 98.5997 39.6127C97.852 39.3582 96.9441 39.231 95.876 39.231C94.6797 39.231 93.8145 39.4006 93.2805 39.74C92.7678 40.0581 92.5114 40.5565 92.5114 41.2351C92.5114 41.6381 92.6076 41.9774 92.7998 42.2531C92.9921 42.5288 93.2591 42.7833 93.6009 43.0166C93.9641 43.2287 94.3699 43.4302 94.8186 43.621C95.2885 43.7907 95.8012 43.971 96.3566 44.1618C97.5102 44.586 98.5142 45.0101 99.3687 45.4343C100.223 45.8373 100.928 46.3144 101.484 46.8658C102.06 47.4172 102.488 48.0641 102.765 48.8064C103.043 49.5486 103.182 50.45 103.182 51.5104C103.182 53.5675 102.456 55.1687 101.003 56.314C99.5503 57.438 97.3607 58 94.434 58C93.4514 58 92.5648 57.9364 91.7744 57.8091C90.984 57.7031 90.2791 57.5652 89.6596 57.3956C89.0614 57.2259 88.5381 57.0456 88.0895 56.8548C87.6622 56.6639 87.2991 56.4836 87 56.314L88.4099 52.3693C89.0721 52.7298 89.8839 53.0586 90.8452 53.3555C91.8279 53.6312 93.0241 53.769 94.434 53.769Z",
    fill: "#4D53E0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M107.028 57.5546V35.509H122.024V39.6763H112.027V44.0028H120.903V48.0747H112.027V53.3873H122.761V57.5546H107.028Z",
    fill: "#4D53E0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M136.586 58C132.976 58 130.22 57.0032 128.319 55.0097C126.439 53.0161 125.499 50.1849 125.499 46.5159C125.499 44.692 125.788 43.0696 126.364 41.6487C126.941 40.2065 127.732 38.9977 128.736 38.0221C129.74 37.0254 130.936 36.2725 132.324 35.7635C133.713 35.2545 135.219 35 136.843 35C137.782 35 138.637 35.0742 139.406 35.2227C140.175 35.3499 140.848 35.509 141.425 35.6999C142.001 35.8695 142.482 36.0498 142.867 36.2407C143.251 36.4315 143.529 36.58 143.7 36.686L142.258 40.6943C141.574 40.3338 140.773 40.0263 139.855 39.7718C138.957 39.5173 137.932 39.39 136.778 39.39C136.009 39.39 135.251 39.5173 134.503 39.7718C133.777 40.0263 133.126 40.4398 132.549 41.0124C131.993 41.5639 131.545 42.2849 131.203 43.1757C130.861 44.0664 130.69 45.148 130.69 46.4205C130.69 47.4385 130.797 48.3928 131.011 49.2835C131.246 50.1531 131.609 50.9059 132.1 51.5422C132.613 52.1784 133.275 52.6874 134.087 53.0692C134.899 53.4297 135.881 53.61 137.035 53.61C137.761 53.61 138.413 53.5675 138.989 53.4827C139.566 53.3979 140.079 53.3024 140.528 53.1964C140.976 53.0692 141.371 52.9313 141.713 52.7829C142.055 52.6344 142.365 52.4965 142.642 52.3693L144.02 56.3458C143.315 56.7699 142.322 57.1517 141.04 57.491C139.758 57.8303 138.274 58 136.586 58Z",
    fill: "#4D53E0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M155.922 58C154.363 58 153.017 57.7879 151.885 57.3638C150.753 56.9184 149.813 56.314 149.065 55.5505C148.339 54.7658 147.794 53.8432 147.431 52.7829C147.089 51.7012 146.918 50.5136 146.918 49.2199V35.509H151.917V48.8064C151.917 49.6971 152.013 50.4606 152.205 51.0968C152.419 51.7118 152.697 52.2208 153.038 52.6238C153.402 53.0055 153.829 53.2812 154.32 53.4509C154.833 53.6206 155.388 53.7054 155.986 53.7054C157.204 53.7054 158.187 53.3343 158.934 52.592C159.703 51.8497 160.088 50.5878 160.088 48.8064V35.509H165.087V49.2199C165.087 50.5136 164.905 51.7012 164.542 52.7829C164.179 53.8645 163.623 54.7976 162.876 55.5823C162.128 56.3458 161.177 56.9396 160.024 57.3638C158.87 57.7879 157.503 58 155.922 58Z",
    fill: "#4D53E0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M176.399 35.2545C179.731 35.2545 182.284 35.8483 184.057 37.036C185.83 38.2024 186.717 40.0263 186.717 42.5076C186.717 44.0558 186.354 45.3177 185.627 46.2932C184.922 47.2476 183.897 48.0005 182.551 48.5519C183 49.1033 183.47 49.7395 183.961 50.4606C184.452 51.1604 184.933 51.9027 185.403 52.6874C185.894 53.4509 186.364 54.2568 186.813 55.1051C187.262 55.9322 187.678 56.7487 188.063 57.5546H182.455C182.049 56.8336 181.633 56.1019 181.205 55.3596C180.8 54.6173 180.372 53.8963 179.924 53.1964C179.496 52.4965 179.069 51.8391 178.642 51.2241C178.215 50.5878 177.787 50.0152 177.36 49.5062H174.893V57.5546H169.894V35.8271C170.984 35.615 172.105 35.4666 173.259 35.3817C174.434 35.2969 175.48 35.2545 176.399 35.2545ZM176.687 39.4855C176.324 39.4855 175.993 39.4961 175.694 39.5173C175.416 39.5385 175.149 39.5597 174.893 39.5809V45.5616H176.303C178.183 45.5616 179.528 45.3283 180.34 44.8617C181.152 44.3951 181.558 43.5998 181.558 42.4758C181.558 41.3942 181.141 40.6307 180.308 40.1853C179.496 39.7188 178.289 39.4855 176.687 39.4855Z",
    fill: "#4D53E0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M191.267 57.5546V35.509H206.263V39.6763H196.266V44.0028H205.141V48.0747H196.266V53.3873H207V57.5546H191.267Z",
    fill: "#4D53E0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M520.361 257.171H359.865V281.842H520.361V257.171Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M520.361 292.215H359.865V316.887H520.361V292.215Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M488.449 334.907H391.818V359.579H488.449V334.907Z",
    fill: "#FF5668"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M353.256 102.431C343.147 93.3397 337.35 80.343 337.35 66.7361V32.6274H424.849V66.7361C424.849 80.3227 419.053 93.3397 408.944 102.431L381.1 127.469L353.256 102.431Z",
    fill: "#4D53E0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M346.137 41.4141H416.083V66.7363C416.083 77.8618 411.364 88.4584 403.086 95.9026L381.12 115.652L359.154 95.9026C350.876 88.4584 346.157 77.8618 346.157 66.7363V41.4141H346.137Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M389.072 75.1158C395.621 75.1158 400.93 69.8069 400.93 63.2581C400.93 56.7093 395.621 51.4004 389.072 51.4004C382.523 51.4004 377.214 56.7093 377.214 63.2581C377.214 69.8069 382.523 75.1158 389.072 75.1158Z",
    fill: "#4D53E0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M389.072 63.2583L368.428 83.9025L374.896 90.35",
    stroke: "#4D53E0",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M378.984 82.8245L374.245 78.0854",
    stroke: "#4D53E0",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M389.072 69.5631C392.554 69.5631 395.377 66.7402 395.377 63.258C395.377 59.7758 392.554 56.9529 389.072 56.9529C385.59 56.9529 382.767 59.7758 382.767 63.258C382.767 66.7402 385.59 69.5631 389.072 69.5631Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M145.043 506H328.035",
    stroke: "#4D53E0",
    strokeWidth: 0.6158,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterImage);
export default __webpack_public_path__ + "static/media/registerImage.c1769a780626edf64d52520959aceaaf.svg";
export { ForwardRef as ReactComponent };